import { Stack } from '@fluentui/react';
import * as React from 'react';
import Inspection from '../Inspection';
import { ISoftwareConfig } from '../../../../../../core/store';
import { noop } from '../../../../../../core/helpers/common';
import { strings } from '../../../../../../localization/strings';
import { IInspectionModeConfigUI } from '@piceasoft/core';
import { SoftwareState } from './preview/SoftwareState';
import { Inspections, IInspectionModeConfig } from "@piceasoft/core";
export type uploadFileType = { imgUrl: string, loadProgress: number, data: File, label?: string }

type TProps = {
    config?: ISoftwareConfig
}

export const SoftwareStatePreview: React.FC<TProps> = (props) => {
    if (props.config === undefined) return null;

    return (
        <Stack grow tokens={{ padding: "32px 32px 32px 32px" }}>
            <Inspection inspection={Inspections.Software}
                icon={props.config.ui?.icon ?? "Camera"}
                title={props.config.ui?.title ?? strings.CONSTRUCTOR.INSPECTIONS.SOFTWARE.TITLE}
                allowRestart={props.config.allowRestart}
                onStart={noop}
                onRestart={noop}
                dependency={props.config.dependency}
                skips={props.config.skip}
                autoRun={props.config.autoRun}
                executeButtonText={props.config.ui?.executeButtonText}
                repeatButtonText={props.config.ui?.restartButtonText}
            >
                <Stack verticalFill tokens={{ childrenGap: 16 }}>
                    <SoftwareState config={props.config.config as IInspectionModeConfig<IInspectionModeConfigUI>}
                    icon={props.config.ui?.icon} />
                </Stack>
            </Inspection>
        </Stack>
    );
}